<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Comprobantes a pagar</h6>
      <p class="text-body-2">Seleccione los comprobantes a pagar</p>
      <div class="col-md-12" v-if="isViewModal"></div>
      <v-row class="mt-0" v-if="!isViewModal && !openFromPaymentOrder">
        <div class="col-md-8">
          <v-combobox
            :disabled="isViewModal || selected_supplier == null"
            v-model="itemSpent.spent"
            data-vv-as="Comprobante"
            name="spent"
            :item-text="spent_name"
            item-value="id"
            :items="spents"
            label="Comprobante*"
            autocomplete="off"
            v-validate="'required|combobox_required'"
            :loading="loading_spent"
            v-on:change="setImporte()"
          ></v-combobox>
          <span class="red--text">{{ errors.first("spent") }}</span>
        </div>
        <div class="col-md-3">
          <v-text-field
            autocomplete="off"
            name="importe"
            label="Importe*"
            :disabled="isViewModal || itemSpent.spent == null"
            placeholder=""
            v-validate="'decimal'"
            type="number"
            v-model="itemSpent.imp_total"
          />
          <span class="red--text">{{ errors.first("importe") }}</span>
        </div>
      </v-row>
      <v-row class="mt-0">
        <v-col md="12" v-if="!isViewModal && !openFromPaymentOrder">
          <v-btn small color="blue-grey" class="text-white" @click="add()">
            <v-icon big color="green"> add </v-icon>
            <span>Agregar item</span>
          </v-btn>
          <v-btn
            small
            
            class="ml-2"
            :disabled="faltanteParaPagoACuenta <= 0 || loading_calc_retenciones || autoBalancing"
            :loading="autoBalancing"
            @click="agregarFaltanteAPagoACuenta()"
          >
            <v-icon small class="mr-1">mdi-cash-plus</v-icon>
            <span>Agregar faltante a Pago a cuenta ({{ formatUtils.formatPrice(faltanteParaPagoACuenta) }})</span>
          </v-btn>
        </v-col>
        <v-col md="12">
          <v-data-table class="pb-4" :headers="header_spents" :items="item.spents" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
            <template v-slot:item="props">
              <tr>
                <td>
                  {{ formatUtils.formatDateString(props.item.spent.cbte_fch) }}
                </td>
                <td>
                  {{ props.item.spent.spent_number_label }}
                </td>
                <td>
                  {{ formatUtils.formatPrice(props.item.imp_total) }}
                </td>
                <td>
                  {{ props.item.spent.id == 0 ? "N/A" : formatUtils.formatPrice(props.item.spent.imp_total) }}
                </td>
                <td>
                  {{ props.item.spent.id == 0 ? "N/A" : formatUtils.formatPrice(props.item.spent.pending_to_paid) }}
                </td>

                <td class="text-center">
                  <v-tooltip bottom v-if="!isViewModal && !openFromPaymentOrder">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="red" @click="remove(props.item)"> indeterminate_check_box </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col md="12" v-if="!isAssignVoucher">
          <v-chip class="float-right" outlined color="primary">Total pagado: {{ formatUtils.formatPrice(total_spents) }} </v-chip>
        </v-col>

        <v-col md="12" class="pt-0" v-if="isAssignVoucher">
          <v-chip class="float-right" color="primary">Total Pago: {{ formatUtils.formatPrice(item.amount) }} </v-chip>
        </v-col>
        <v-col md="12" class="pt-0" v-if="isAssignVoucher">
          <v-chip class="float-right" outlined color="primary">Total a imputar: {{ formatUtils.formatPrice(total_spents) }} </v-chip>
        </v-col>
        <v-col md="12" class="pt-0" v-if="isAssignVoucher">
          <v-chip class="float-right" outlined color="primary">Saldo pendiente: {{ formatUtils.formatPrice(parseFloat(item.amount) - parseFloat(total_spents)) }} </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { emitterUtils } from "@/libs/utils/emitterUtils";
import { spentService } from "@/libs/ws/spentService";

export default {
  created() {
    //sacamos el validador del padre, para que solo validar al hijo aca.
    //this.$validator = this.validator;
  },
  components: {},
  props: {
    item: Object,
    validator: Object,
    isViewModal: { type: Boolean, default: false },
    isAssignVoucher: { type: Boolean, default: false },
    openFromCreateGasto: { type: Boolean, default: false },
    openFromPaymentOrder: { type: Boolean, default: false },
    spent: { type: Object, default: null },
    open: Boolean,
    receiver: { type: Object, default: null },
    loading_calc_retenciones: { type: Boolean, default: false },
  },
  data: () => ({
    header_spents: [{text: "Fecha Comprobante"},{ text: "Comprobante" }, { text: "Importe a imputar" }, { text: "Total Gasto" }, { text: "Pendiente de pago" }, { text: "", value: "", sortable: false, class: "bg-grey" }],
    formatUtils: formatUtils,
    spents: [],
    total_spents: 0,
    selected_supplier: null,
    loading_spent: false,
    autoBalancing: false,
    autoBalanceIterations: 0,
    defaultItemSpent: null,
    itemSpent: {
      id: 0,
      spent: null,
      imp_total: 0,
      imp_iva: 0,
      imp_neto: 0,
      imp_op_ex: 0,
      imp_tributo: 0,
    },
  }),
  computed: {
    // Faltante que debe cubrir un Pago a cuenta para que el total cuadre:
    // (Σ formas de pago + Σ retenciones) − Σ comprobantes a pagar
    faltanteParaPagoACuenta() {
      const totalFormasPago = (this.item.spent_payment_methods || []).reduce(
        (acc, pm) => acc + parseFloat(pm.amount || 0), 0
      );
      const totalRetenciones = (this.item.tributes || []).reduce(
        (acc, t) => acc + parseFloat(t.amount || 0), 0
      );
      const totalComprobantes = (this.item.spents || []).reduce(
        (acc, s) => acc + parseFloat(s.imp_total || 0), 0
      );
      const faltante = totalFormasPago + totalRetenciones - totalComprobantes;
      return Math.max(0, Math.round(faltante * 100) / 100);
    },
    anchorReceiverId() {
      return emitterUtils.anchorEmitterId([
        { emitter: this.receiver != null ? this.receiver : this.item.receiver },
        { list: this.item.spents, key: "spent" },
        { list: this.item.spent_payment_methods, key: "money_account" },
      ]);
    },
  },
  watch: {
    item: {
      handler: function (newValue) {
        if ((newValue.supplier != null && this.selected_supplier == null) || (newValue.supplier != null && this.selected_supplier != null && newValue.supplier.id != this.selected_supplier.id)) {
          this.selected_supplier = newValue.supplier;
          if (!this.isViewModal) this.getVourchers();
        }
      },
      deep: true,
    },
    open: function (newValue) {
      if (this.spent != null) {
        this.itemSpent.spent = this.spent;
        this.itemSpent.imp_total = this.spent.pending_to_paid;

        if (this.openFromCreateGasto) {
          this.item.spents.push(this.itemSpent);
        }
      }
      this.itemSpent = JSON.parse(JSON.stringify(this.defaultItemSpent));
      this.getVourchers();
      this.$validator.reset();
      if (this.isViewModal && this.item.pago_a_cuenta > 0) {
        this.addVoucherACuenta();
      }

      if (!newValue) {
        //CloseModal
        this.spents = [];
        this.total_spents = 0;
        this.selected_supplier = null;
      }
    },
    "item.spents": {
      handler: function (newValue) {
        this.calcTotalSpents();
      },
      deep: true,
    },
    receiver: function (newValue) {
      this.itemSpent = JSON.parse(JSON.stringify(this.defaultItemSpent));
      this.getVourchers();
    },
    //Cuando termina un recálculo de retenciones durante el auto-balance,
    //si aún queda faltante, se aplica de nuevo hasta converger (con tope de seguridad).
    loading_calc_retenciones: function (newValue, oldValue) {
      if (oldValue === true && newValue === false && this.autoBalancing) {
        if (this.faltanteParaPagoACuenta > 0.01 && this.autoBalanceIterations < 5) {
          this.$nextTick(() => this.aplicarFaltantePagoACuenta());
        } else {
          this.autoBalancing = false;
          this.autoBalanceIterations = 0;
        }
      }
    },
  },
  mounted() {
    this.defaultItemSpent = JSON.parse(JSON.stringify(this.itemSpent));
    if (this.spent != null) {
      this.itemSpent.spent = this.spent;
      this.itemSpent.imp_total = this.spent.pending_to_paid;
    }
    if (this.item != null && this.item.supplier != null) {
      this.selected_supplier = this.item.supplier;
      this.getVourchers();
    }
    if (this.isViewModal && this.item.pago_a_cuenta > 0) {
      this.addVoucherACuenta();
    }
    this.calcTotalSpents();
  },
  methods: {
    addVoucherACuenta() {
      this.itemSpent.spent = { id: 0, cbte_fch: (new Date()).toISOString().split('T')[0], spent_number_label: "Pago a cuenta", voucher_number: null };
      this.itemSpent.imp_total = this.item.pago_a_cuenta;
      this.item.spents.push(this.itemSpent);
      this.itemSpent = JSON.parse(JSON.stringify(this.defaultItemSpent));
    },
    agregarFaltanteAPagoACuenta() {
      if (this.faltanteParaPagoACuenta <= 0) return;
      //Inicia una sesión de auto-balance: aplica el faltante y, tras cada
      //recálculo de retenciones, se re-aplica el residuo hasta que quede en 0.
      this.autoBalancing = true;
      this.autoBalanceIterations = 0;
      this.aplicarFaltantePagoACuenta();
    },
    aplicarFaltantePagoACuenta() {
      const faltante = this.faltanteParaPagoACuenta;
      if (faltante <= 0) {
        this.autoBalancing = false;
        this.autoBalanceIterations = 0;
        return;
      }
      this.autoBalanceIterations++;

      const index = this.item.spents.findIndex((s) => s.spent && s.spent.id == 0);
      if (index > -1) {
        //Sumar al pago a cuenta existente
        const nuevoImporte = parseFloat(this.item.spents[index].imp_total) + faltante;
        this.item.spents[index].imp_total = Math.round(nuevoImporte * 100) / 100;
      } else {
        //Crear un nuevo pago a cuenta con el importe faltante
        const nuevoPagoACuenta = JSON.parse(JSON.stringify(this.defaultItemSpent));
        nuevoPagoACuenta.spent = { id: 0, cbte_fch: (new Date()).toISOString().split('T')[0], spent_number_label: "Pago a cuenta", voucher_number: null };
        nuevoPagoACuenta.imp_total = faltante;
        this.item.spents.push(nuevoPagoACuenta);

        //Remover el pseudo "Pago a cuenta" de la lista de comprobantes disponibles
        const index_disp = this.spents.findIndex((o) => o.id === 0);
        if (index_disp > -1) this.spents.splice(index_disp, 1);
      }
    },
    calcTotalSpents() {
      this.total_spents = 0;
      this.item.spents.forEach((element) => {
        this.total_spents += parseFloat(element.imp_total);
      });
      this.total_spents = this.total_spents.toFixed(2);
    },
    spent_name: (item) => (item.id != 0 ? formatUtils.formatDateString(item.cbte_fch) + " - " + item.spent_number_label + " - (Pendiente de pago " + formatUtils.formatPrice(item.pending_to_paid) + ") " : item.spent_number_label),
    setImporte() {
      if (this.itemSpent.spent != null && this.itemSpent.spent.id != 0) {
        this.itemSpent.imp_total = this.itemSpent.spent.pending_to_paid;        
      }
    },
    add() {
      if (this.itemSpent.imp_total <= 0) {
        this.$toast.error("El importe debe ser mayor a 0");
        return;
      }        

      //se valida contra el acumulado ya imputado del mismo comprobante, no solo contra el importe nuevo
      const ya_imputado = this.item.spents.filter((objeto) => objeto.spent && objeto.spent.id === this.itemSpent.spent.id).reduce((acc, objeto) => acc + parseFloat(objeto.imp_total || 0), 0);

      if (this.itemSpent.spent.id != 0 && ya_imputado + parseFloat(this.itemSpent.imp_total) > parseFloat(this.itemSpent.spent.pending_to_paid)) {
        this.$toast.error("El importe a imputar no puede ser mayor al pendiente de pago (Code: 2)");
        return;
      }

      //se hace lo de parseFloat(...) porque el toFixed devuelve un string
      if (this.isAssignVoucher && parseFloat(parseFloat(this.item.amount).toFixed(2)) < (parseFloat( (this.total_spents) + parseFloat(this.itemSpent.imp_total)).toFixed(2) )) {
        this.$toast.error("El importe a imputar no puede ser mayor al saldo pendiente (Code: 3)");
        return;
      }

      const newReceiverId = emitterUtils.emitterIdOf(this.itemSpent.spent);
      const anchor = this.anchorReceiverId;
      if (newReceiverId != null && anchor != null && newReceiverId != anchor) {
        this.$toast.error("El comprobante pertenece a un receptor distinto al de las formas de pago");
        return;
      }

      this.$validator.validateAll().then((valid) => {
        if (valid) {
          //remuevo el spent de la lista de spents pendientes
          console.log("itemSpent.spent", this.itemSpent.spent);
          const index_item = this.spents.findIndex((objeto) => objeto.id === this.itemSpent.spent.id);
          if (index_item > -1) this.spents.splice(index_item, 1);

          //busco si el item ya existe en la lista y le sumo el importe a imputar
          const index_item_spent = this.item.spents.findIndex((objeto) => objeto.spent.id === this.itemSpent.spent.id);
          if (index_item_spent > -1) {
            this.item.spents[index_item_spent].imp_total = parseFloat(this.item.spents[index_item_spent].imp_total) + parseFloat(this.itemSpent.imp_total);
          } else {
            this.item.spents.push(this.itemSpent);
          }
          this.itemSpent = JSON.parse(JSON.stringify(this.defaultItemSpent));
          this.$validator.reset();
        }
      });
    },
    remove(item) {
      const index_item = this.item.spents.indexOf(item);
      if (index_item > -1) this.item.spents.splice(index_item, 1);

      //agrego el spent a la lista de spents pendientes
      if (item.spent.id != 0) {
        this.spents.push(item.spent);
      } else {
        this.spents.unshift(item.spent);
      }
    },
    getVourchers() {
      if (this.item.supplier == null) {
        return;
      }
      this.loading_spent = true;
      var param = {
        supplier: this.item.supplier.id,
      };
      if (this.receiver && this.receiver.id > 0) {
        param.receiver_id = this.receiver.id;
      }

      spentService
        .getPendingSpents(param)
        .then((response) => {
          //se excluyen los comprobantes que ya estan cargados en la grilla, sino vuelven a aparecer
          //en el combo y se pueden imputar dos veces (sumando el importe sobre el item existente)
          const ya_imputados = (this.item.spents || []).filter((objeto) => objeto.spent != null).map((objeto) => objeto.spent.id);
          this.spents = response.result.filter((objeto) => !ya_imputados.includes(objeto.id));

          if (!this.isAssignVoucher && !ya_imputados.includes(0)) {
            var pago_a_cuenta = { id: 0, cbte_fch: (new Date()).toISOString().split('T')[0],spent_number_label: "Pago a cuenta", voucher_number: null };
            this.spents.unshift(pago_a_cuenta);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading_spent = false;
        });
    },
  },
};
</script>
